interface Props {
  fill?: string;
  bgFill?: string;
  width?: string;
  height?: string;
  className?: string;
}
export const ECommerceIcon: React.FC<Props> = ({ fill = '#081120' }) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 7.00033H17.5C17.5 5.06733 15.933 3.50033 14 3.50033C12.0669 3.50033 10.5 5.06733 10.5 7.00033ZM8.16667 7.00033C8.16667 3.77867 10.7783 1.16699 14 1.16699C17.2216 1.16699 19.8333 3.77867 19.8333 7.00033H23.3333C23.9777 7.00033 24.5 7.52267 24.5 8.16699V24.5003C24.5 25.1447 23.9777 25.667 23.3333 25.667H4.66667C4.02234 25.667 3.5 25.1447 3.5 24.5003V8.16699C3.5 7.52267 4.02234 7.00033 4.66667 7.00033H8.16667ZM5.83333 9.33366V23.3337H22.1667V9.33366H5.83333ZM10.5 11.667C10.5 13.6 12.0669 15.167 14 15.167C15.933 15.167 17.5 13.6 17.5 11.667H19.8333C19.8333 14.8886 17.2216 17.5003 14 17.5003C10.7783 17.5003 8.16667 14.8886 8.16667 11.667H10.5Z"
      fill={fill}
    />
  </svg>
);

export const LogisticsBike: React.FC<Props> = ({ fill = '#8E8E93' }) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.6654 0.166992C17.3097 0.166992 17.832 0.689332 17.832 1.33366V2.50033H23.6654V9.50033H21.3102L24.5136 18.3015C24.7192 18.8276 24.832 19.4002 24.832 19.9992C24.832 22.5766 22.7426 24.6658 20.1654 24.6658C17.9913 24.6658 16.1645 23.1791 15.646 21.167H10.685C10.1669 23.1797 8.33984 24.667 6.16536 24.667C3.89679 24.667 2.00629 23.0482 1.58589 20.9029C0.840651 20.5132 0.332031 19.7328 0.332031 18.8337V7.16699C0.332031 6.52267 0.854371 6.00033 1.4987 6.00033H9.66536C10.3097 6.00033 10.832 6.52267 10.832 7.16699V13.0003C10.832 13.6447 11.3543 14.167 11.9987 14.167H14.332C14.9764 14.167 15.4987 13.6447 15.4987 13.0003V2.50033H11.9987V0.166992H16.6654ZM6.16536 17.667C4.8767 17.667 3.83203 18.7116 3.83203 20.0003C3.83203 21.289 4.8767 22.3337 6.16536 22.3337C7.45403 22.3337 8.4987 21.289 8.4987 20.0003C8.4987 18.7116 7.45403 17.667 6.16536 17.667ZM20.1654 17.6658C18.8767 17.6658 17.832 18.7105 17.832 19.9992C17.832 21.2879 18.8767 22.3325 20.1654 22.3325C21.4541 22.3325 22.4987 21.2879 22.4987 19.9992C22.4987 19.7188 22.4492 19.4499 22.3586 19.2009L22.3394 19.1503C21.9999 18.2814 21.1546 17.6658 20.1654 17.6658ZM18.8272 9.50033H17.832V13.0003C17.832 14.9334 16.2651 16.5003 14.332 16.5003H11.9987C10.0656 16.5003 8.4987 14.9334 8.4987 13.0003H2.66536V16.9136C3.52046 15.9448 4.77156 15.3337 6.16536 15.3337C8.33984 15.3337 10.1669 16.8209 10.685 18.8337H15.6455C16.1631 16.8203 17.9905 15.3325 20.1654 15.3325C20.4416 15.3325 20.7123 15.3565 20.9754 15.4026L18.8272 9.50033ZM8.4987 8.33366H2.66536V10.667H8.4987V8.33366ZM21.332 4.83366H17.832V7.16699H21.332V4.83366Z"
      fill={fill}
    />
  </svg>
);

export const StackedOutline: React.FC<Props> = ({ fill = '#8E8E93' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.66667 2.83333H20.3333V0.5H1.66667V2.83333ZM20.3333 7.5H1.66667V5.16667H20.3333V7.5ZM0.5 9.83333H8.66667V12.1667H13.3333V9.83333H21.5V20.3333C21.5 20.9777 20.9777 21.5 20.3333 21.5H1.66667C1.02234 21.5 0.5 20.9777 0.5 20.3333V9.83333ZM15.6667 12.1667V14.5H6.33333V12.1667H2.83333V19.1667H19.1667V12.1667H15.6667Z"
      fill={fill}
    />
  </svg>
);

export const WalletOutline: React.FC<Props> = ({ fill = '#8E8E93' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.6732 5.16667H24.8399V16.8333H23.6732V20.3333C23.6732 20.9777 23.1509 21.5 22.5065 21.5H1.50651C0.862184 21.5 0.339844 20.9777 0.339844 20.3333V1.66667C0.339844 1.02233 0.862184 0.5 1.50651 0.5H22.5065C23.1509 0.5 23.6732 1.02233 23.6732 1.66667V5.16667ZM21.3399 16.8333H14.3399C11.1182 16.8333 8.50651 14.2216 8.50651 11C8.50651 7.77833 11.1182 5.16667 14.3399 5.16667H21.3399V2.83333H2.67318V19.1667H21.3399V16.8333ZM22.5065 14.5V7.5H14.3399C12.4068 7.5 10.8399 9.06696 10.8399 11C10.8399 12.9329 12.4068 14.5 14.3399 14.5H22.5065ZM14.3399 9.83334H17.8399V12.1667H14.3399V9.83334Z"
      fill={fill}
    />
  </svg>
);

export const ProfileOutline: React.FC<Props> = ({ fill = '#8E8E93' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM12.1916 16.8C9.74916 16.8 7.55018 17.8424 6.01531 19.5067C7.65647 20.8169 9.7368 21.6 12 21.6C14.3634 21.6 16.5272 20.746 18.1999 19.3297C16.6747 17.7689 14.5463 16.8 12.1916 16.8ZM12 2.4C6.69806 2.4 2.4 6.69806 2.4 12C2.4 14.1727 3.1218 16.1768 4.33868 17.7857C6.30767 15.7009 9.09773 14.4 12.1916 14.4C15.1729 14.4 17.872 15.6079 19.8262 17.561C20.9431 15.992 21.6 14.0728 21.6 12C21.6 6.69806 17.302 2.4 12 2.4ZM12 3.6C14.6509 3.6 16.8 5.74903 16.8 8.4C16.8 11.0509 14.6509 13.2 12 13.2C9.34903 13.2 7.2 11.0509 7.2 8.4C7.2 5.74903 9.34903 3.6 12 3.6ZM12 6C10.6745 6 9.6 7.07452 9.6 8.4C9.6 9.72552 10.6745 10.8 12 10.8C13.3255 10.8 14.4 9.72552 14.4 8.4C14.4 7.07452 13.3255 6 12 6Z"
      fill={fill}
    />
  </svg>
);

export const SettingsOutline: React.FC<Props> = ({ fill = '#8E8E93' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.332031 11.9998C0.332031 10.9912 0.460014 10.0125 0.70064 9.07903C1.97262 9.14497 3.23526 8.51184 3.9158 7.33312C4.59581 6.15529 4.51343 4.74649 3.82178 3.67818C5.21283 2.31117 6.94507 1.29025 8.87907 0.754883C9.45793 1.88949 10.6375 2.66645 11.9987 2.66645C13.3598 2.66645 14.5395 1.88949 15.1184 0.754883C17.0523 1.29025 18.7846 2.31117 20.1756 3.67818C19.4839 4.74649 19.4015 6.15529 20.0816 7.33312C20.7621 8.51184 22.0248 9.14497 23.2968 9.07903C23.5374 10.0125 23.6654 10.9912 23.6654 11.9998C23.6654 13.0083 23.5374 13.9871 23.2968 14.9205C22.0248 14.8546 20.7621 15.4877 20.0816 16.6664C19.4015 17.8443 19.4839 19.253 20.1756 20.3214C18.7846 21.6883 17.0523 22.7093 15.1184 23.2447C14.5395 22.1101 13.3598 21.3331 11.9987 21.3331C10.6375 21.3331 9.45793 22.1101 8.87907 23.2447C6.94507 22.7093 5.21283 21.6883 3.82178 20.3214C4.51343 19.253 4.59581 17.8443 3.9158 16.6664C3.23526 15.4877 1.97262 14.8546 0.70064 14.9205C0.460014 13.9871 0.332031 13.0083 0.332031 11.9998ZM5.93652 15.4998C6.67164 16.7731 6.88237 18.2369 6.59491 19.6109C7.07066 19.9494 7.57709 20.2427 8.10774 20.4864C9.15409 19.5497 10.5278 18.9998 11.9987 18.9998C13.4696 18.9998 14.8433 19.5497 15.8896 20.4864C16.4202 20.2427 16.9267 19.9494 17.4025 19.6109C17.115 18.2369 17.3257 16.7731 18.0609 15.4998C18.7959 14.2266 19.9583 13.3123 21.2918 12.8742C21.3185 12.5851 21.332 12.2935 21.332 11.9998C21.332 11.7061 21.3185 11.4144 21.2918 11.1255C19.9583 10.6874 18.7959 9.77306 18.0609 8.49979C17.3257 7.22652 17.115 5.76274 17.4025 4.38872C16.9267 4.05019 16.4202 3.75688 15.8896 3.5131C14.8433 4.44984 13.4696 4.99979 11.9987 4.99979C10.5278 4.99979 9.15409 4.44984 8.10774 3.5131C7.57709 3.75688 7.07066 4.05019 6.59491 4.38872C6.88237 5.76274 6.67164 7.22652 5.93652 8.49979C5.20142 9.77306 4.03916 10.6874 2.70563 11.1255C2.67886 11.4144 2.66536 11.7061 2.66536 11.9998C2.66536 12.2935 2.67886 12.5851 2.70563 12.8742C4.03916 13.3123 5.20142 14.2266 5.93652 15.4998ZM11.9987 15.4998C10.0656 15.4998 8.4987 13.9328 8.4987 11.9998C8.4987 10.0668 10.0656 8.49979 11.9987 8.49979C13.9317 8.49979 15.4987 10.0668 15.4987 11.9998C15.4987 13.9328 13.9317 15.4998 11.9987 15.4998ZM11.9987 13.1664C12.643 13.1664 13.1654 12.6441 13.1654 11.9998C13.1654 11.3554 12.643 10.8331 11.9987 10.8331C11.3543 10.8331 10.832 11.3554 10.832 11.9998C10.832 12.6441 11.3543 13.1664 11.9987 13.1664Z"
      fill={fill}
    />
  </svg>
);

export const ApiOutline: React.FC<Props> = ({ fill = '#8E8E93' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.1667 3.99992H3.83333C2.53834 3.99992 1.5 5.03825 1.5 6.33325V17.6666C1.5 18.9616 2.53834 20 3.83333 20H20.1667C21.4617 20 22.5 18.9616 22.5 17.6666V6.33325C22.5 5.03825 21.4617 3.99992 20.1667 3.99992ZM20.1667 17.6666H3.83333V7.33325H20.1667V17.6666Z"
      fill={fill}
    />
  </svg>
);

export const LeafIconWonWithBG: React.FC<Props> = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="56" rx="4" fill="#EFEDFE" />
    <path
      d="M39.996 16V18.6667C39.996 31.5032 32.8327 37.3333 23.9961 37.3333L18.9864 37.3332C18.7702 38.5493 18.6628 39.876 18.6628 41.3333H15.9961C15.9961 39.5164 16.1504 37.8663 16.4571 36.3576C16.1498 34.6321 15.9961 32.2901 15.9961 29.3333C15.9961 21.9695 21.9656 16 29.3294 16C31.996 16 34.6627 17.3333 39.996 16ZM29.3294 18.6667C23.4384 18.6667 18.6628 23.4423 18.6628 29.3333C18.6628 29.8165 18.667 30.2815 18.6755 30.7279C20.348 28.0912 22.7974 26.0064 26.0012 24.1757L27.3243 26.4909C23.5178 28.6661 20.9927 31.138 19.6964 34.6664L23.9961 34.6667C32.0163 34.6667 37.1576 29.3692 37.3252 19.1835C35.4959 19.3615 33.7962 19.248 31.6992 18.9335C30.1644 18.7032 29.8638 18.6667 29.3294 18.6667Z"
      fill="#5A4AF2"
    />
  </svg>
);

export const CutleryIconWonWithBG: React.FC<Props> = ({
  fill = '#006475',
  bgFill = '#E6EDEE',
  width = '56',
  height = '56',
  className = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect width="56" height="56" rx="4" fill={bgFill} />
    <path
      d="M40 14.1665V40.8332H37.3333V31.4998H32V22.1665C32 17.7482 35.5817 14.1665 40 14.1665ZM37.3333 17.5398C36.2267 18.1665 34.6667 19.7265 34.6667 22.1665V28.8332H37.3333V17.5398ZM24 30.0332V40.8332H21.3333V30.0332C18.2903 29.4154 16 26.7252 16 23.4998V15.4998H18.6667V24.8332H21.3333V15.4998H24V24.8332H26.6667V15.4998H29.3333V23.4998C29.3333 26.7252 27.0429 29.4154 24 30.0332Z"
      fill={fill}
    />
  </svg>
);

export const BasketIconWonWithBG: React.FC<Props> = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="56" rx="4" fill="#FFF9E4" />
    <path
      d="M28.0052 14.6665C32.4235 14.6665 36.0052 18.2482 36.0052 22.6665V23.9998H41.3386V26.6665H39.7826L38.7738 38.7772C38.7162 39.4682 38.1384 39.9998 37.445 39.9998H18.5654C17.8719 39.9998 17.2942 39.4682 17.2367 38.7772L16.2265 26.6665H14.6719V23.9998H20.0052V22.6665C20.0052 18.2482 23.5869 14.6665 28.0052 14.6665ZM37.1066 26.6665H18.9025L19.7919 37.3332H36.2172L37.1066 26.6665ZM29.3386 29.3332V34.6665H26.6719V29.3332H29.3386ZM24.0052 29.3332V34.6665H21.3385V29.3332H24.0052ZM34.6719 29.3332V34.6665H32.0052V29.3332H34.6719ZM28.0052 17.3332C25.149 17.3332 22.8171 19.5785 22.6784 22.4003L22.6719 22.6665V23.9998H33.3386V22.6665C33.3386 19.8102 31.0932 17.4784 28.2714 17.3397L28.0052 17.3332Z"
      fill="#FCCD33"
    />
  </svg>
);

export const WearIconWonWithBG: React.FC<Props> = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="56" rx="4" fill="#FFF2EA" />
    <g clipPath="url(#clip0_56755_32315)">
      <path
        d="M42.7721 19.2375L36.7621 15.7063C36.5315 15.5703 36.2685 15.499 36.0008 15.5H32.0008C31.603 15.5 31.2215 15.658 30.9402 15.9394C30.6588 16.2207 30.5008 16.6022 30.5008 17C30.5008 17.6631 30.2374 18.2989 29.7686 18.7678C29.2997 19.2366 28.6639 19.5 28.0008 19.5C27.3378 19.5 26.7019 19.2366 26.233 18.7678C25.7642 18.2989 25.5008 17.6631 25.5008 17C25.5008 16.6022 25.3428 16.2207 25.0615 15.9394C24.7802 15.658 24.3986 15.5 24.0008 15.5H20.0008C19.7339 15.4998 19.4718 15.5715 19.2421 15.7075L13.2296 19.2375C12.6882 19.5606 12.2875 20.0748 12.1064 20.6786C11.9252 21.2825 11.9768 21.9323 12.2508 22.5L14.4883 27.1C14.6878 27.5199 15.0025 27.8744 15.3958 28.1223C15.7891 28.3702 16.2447 28.5012 16.7096 28.5H18.5008V38C18.5008 38.6631 18.7642 39.2989 19.233 39.7678C19.7019 40.2366 20.3378 40.5 21.0008 40.5H35.0008C35.6639 40.5 36.2997 40.2366 36.7686 39.7678C37.2374 39.2989 37.5008 38.6631 37.5008 38V28.5H39.2908C39.7548 28.5007 40.2095 28.3699 40.6022 28.1228C40.9948 27.8757 41.3095 27.5224 41.5096 27.1038L43.7508 22.5C44.0249 21.9323 44.0764 21.2825 43.8952 20.6786C43.7141 20.0748 43.3134 19.5606 42.7721 19.2375ZM17.0471 25.5L15.1458 21.5913L18.5008 19.625V25.5H17.0471ZM34.5008 37.5H21.5008V18.5H22.7096C23.0355 19.6526 23.7287 20.6673 24.684 21.3899C25.6392 22.1125 26.8043 22.5035 28.0021 22.5035C29.1998 22.5035 30.3649 22.1125 31.3201 21.3899C32.2754 20.6673 32.9687 19.6526 33.2946 18.5H34.5008V37.5ZM38.9533 25.5H37.5008V19.625L40.8546 21.595L38.9533 25.5Z"
        fill="#F7742B"
      />
    </g>
    <defs>
      <clipPath id="clip0_56755_32315">
        <rect
          width="32"
          height="32"
          fill="white"
          transform="translate(12 12)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const CalendarIconWonWithBG: React.FC<Props> = ({ className }) => (
  <svg
    className={className}
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="56" rx="4" fill="#F2F2F7" />
    <path
      d="M24.0013 13.3335V16.0002H32.0013V13.3335H34.668V16.0002H40.0013C40.7377 16.0002 41.3346 16.5971 41.3346 17.3335V38.6668C41.3346 39.4032 40.7377 40.0002 40.0013 40.0002H16.0013C15.2649 40.0002 14.668 39.4032 14.668 38.6668V17.3335C14.668 16.5971 15.2649 16.0002 16.0013 16.0002H21.3346V13.3335H24.0013ZM38.668 26.6668H17.3346V37.3335H38.668V26.6668ZM22.668 30.6668V33.3335H20.0013V30.6668H22.668ZM36.0013 30.6668V33.3335H25.3346V30.6668H36.0013ZM21.3346 18.6668H17.3346V24.0002H38.668V18.6668H34.668V21.3335H32.0013V18.6668H24.0013V21.3335H21.3346V18.6668Z"
      fill="#636366"
    />
  </svg>
);

export const BackIconWonWithBG: React.FC<Props> = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="16" fill="white" />
    <path
      d="M14.8284 16.0007L19.7782 20.9504L18.364 22.3646L12 16.0007L18.364 9.63672L19.7782 11.0509L14.8284 16.0007Z"
      fill="#636366"
    />
  </svg>
);

export const LogisticsBoxWithBG: React.FC<Props> = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="56" rx="4" fill="#F2F2F7" />
    <path
      d="M27.9987 13.3333L40.6654 20.6666V35.3333L27.9987 42.6666L15.332 35.3333V20.6666L27.9987 13.3333ZM19.3239 21.4369L27.9988 26.4592L36.6736 21.437L27.9987 16.4146L19.3239 21.4369ZM17.9987 23.751V33.7958L26.6655 38.8134V28.7686L17.9987 23.751ZM29.3322 38.8133L37.9987 33.7958V23.7511L29.3322 28.7686V38.8133Z"
      fill="#636366"
    />
  </svg>
);

export const CalendarIcon: React.FC<Props> = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5013 0.833008V2.49967H12.5013V0.833008H14.168V2.49967H17.5013C17.9616 2.49967 18.3346 2.87277 18.3346 3.33301V16.6663C18.3346 17.1266 17.9616 17.4997 17.5013 17.4997H2.5013C2.04107 17.4997 1.66797 17.1266 1.66797 16.6663V3.33301C1.66797 2.87277 2.04107 2.49967 2.5013 2.49967H5.83464V0.833008H7.5013ZM16.668 9.16634H3.33464V15.833H16.668V9.16634ZM6.66797 10.833V12.4997H5.0013V10.833H6.66797ZM10.8346 10.833V12.4997H9.16797V10.833H10.8346ZM15.0013 10.833V12.4997H13.3346V10.833H15.0013ZM5.83464 4.16634H3.33464V7.49967H16.668V4.16634H14.168V5.83301H12.5013V4.16634H7.5013V5.83301H5.83464V4.16634Z"
      fill="#8E8E93"
    />
  </svg>
);

export const DropdownIcon: React.FC<Props> = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99861 10.9763L14.1234 6.85156L15.3019 8.03007L9.99861 13.3334L4.69531 8.03007L5.87383 6.85156L9.99861 10.9763Z"
      fill="#8E8E93"
    />
  </svg>
);

export const PlusIcon: React.FC<Props> = ({ fill = '#5A4AF2' }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6 6V0H8V6H14V8H8V14H6V8H0V6H6Z" fill={fill} />
  </svg>
);

export const DeleteIcon: React.FC<Props> = ({
  fill = '#F7742B',
  width = '14',
  height = '14',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.9 4V14.4C14.9 15.2837 14.1837 16 13.3 16H3.7C2.81634 16 2.1 15.2837 2.1 14.4V4H0.5V2.4H16.5V4H14.9ZM3.7 4V14.4H13.3V4H3.7ZM7.7 5.6H9.3V7.2H7.7V5.6ZM7.7 8H9.3V9.6H7.7V8ZM7.7 10.4H9.3V12H7.7V10.4ZM4.5 0H12.5V1.6H4.5V0Z"
      fill={fill}
    />
  </svg>
);

export const PencilIcon: React.FC<Props> = ({ fill = '#081120' }) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6066 7.97999L12.4281 6.80148L4.66667 14.5629V15.7414H5.84517L13.6066 7.97999ZM14.7851 6.80148L15.9636 5.62298L14.7851 4.44446L13.6066 5.62298L14.7851 6.80148ZM6.53553 17.4081H3V13.8725L14.1958 2.67669C14.5213 2.35126 15.0489 2.35126 15.3743 2.67669L17.7314 5.03372C18.0568 5.35915 18.0568 5.88679 17.7314 6.21223L6.53553 17.4081Z"
      fill={fill}
    />
  </svg>
);

export const EditPencilIcon: React.FC<Props> = ({ fill = '#054853' }) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.75 14.1693H4.81066L11.7959 7.18404L10.7353 6.12339L3.75 13.1087V14.1693ZM15.75 15.6693H2.25V12.4873L12.3263 2.41107C12.6192 2.11818 13.094 2.11818 13.3869 2.41107L15.5083 4.5324C15.8012 4.82529 15.8012 5.30016 15.5083 5.59305L6.93198 14.1693H15.75V15.6693ZM11.7959 5.06273L12.8566 6.12339L13.9172 5.06273L12.8566 4.00206L11.7959 5.06273Z"
      fill={fill}
    />
  </svg>
);

export const CopyDoubleIcon: React.FC<Props> = ({ fill = '#F7F7F7' }) => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.24985 3.5V1.25C3.24985 0.83579 3.58564 0.5 3.99985 0.5H12.9998C13.4141 0.5 13.7498 0.83579 13.7498 1.25V11.75C13.7498 12.1642 13.4141 12.5 12.9998 12.5H10.7498V14.7493C10.7498 15.1639 10.4124 15.5 9.99475 15.5H1.00499C0.587942 15.5 0.25 15.1665 0.25 14.7493L0.25195 4.25065C0.252025 3.83608 0.58948 3.5 1.00706 3.5H3.24985ZM1.75181 5L1.75014 14H9.24985V5H1.75181ZM4.74985 3.5H10.7498V11H12.2498V2H4.74985V3.5Z"
      fill={fill}
    />
  </svg>
);

export const PrintInvoiceIcon: React.FC<Props> = ({ fill = '#F7F7F7' }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.75 1.5C13.1642 1.5 13.5 1.83579 13.5 2.25V5.25H15.75C16.1642 5.25 16.5 5.58579 16.5 6V13.5C16.5 13.9142 16.1642 14.25 15.75 14.25H13.5V15.75C13.5 16.1642 13.1642 16.5 12.75 16.5H5.25C4.83579 16.5 4.5 16.1642 4.5 15.75V14.25H2.25C1.83579 14.25 1.5 13.9142 1.5 13.5V6C1.5 5.58579 1.83579 5.25 2.25 5.25H4.5V2.25C4.5 1.83579 4.83579 1.5 5.25 1.5H12.75ZM12 12.75H6V15H12V12.75ZM15 6.75H3V12.75H4.5V12C4.5 11.5858 4.83579 11.25 5.25 11.25H12.75C13.1642 11.25 13.5 11.5858 13.5 12V12.75H15V6.75ZM6 7.5V9H3.75V7.5H6ZM12 3H6V5.25H12V3Z"
      fill={fill}
    />
  </svg>
);
export const MoneyIcon: React.FC<Props> = ({
  fill = '#E6EDEE',
  bgFill = '#006475',
}) => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="56" rx="4" fill={fill} />
    <path
      d="M27.9992 33.333C30.9447 33.333 33.3326 30.9451 33.3326 27.9997C33.3326 25.0542 30.9447 22.6663 27.9992 22.6663C25.0537 22.6663 22.6659 25.0542 22.6659 27.9997C22.6659 30.9451 25.0537 33.333 27.9992 33.333ZM40.0052 17.3369H16.0052C15.2688 17.3369 14.6719 17.9339 14.6719 18.6702V37.3369C14.6719 38.0733 15.2688 38.6702 16.0052 38.6702H40.0052C40.7416 38.6702 41.3386 38.0733 41.3386 37.3369V18.6702C41.3386 17.9339 40.7416 17.3369 40.0052 17.3369ZM17.3385 32.8614V23.138C18.8396 22.689 20.0232 21.5049 20.4714 20.0036H35.527C35.9764 21.5089 37.1651 22.6953 38.6719 23.1415V32.8578C37.1626 33.3047 35.9723 34.4945 35.5246 36.0035H20.4738C20.0273 34.4986 18.8422 33.3111 17.3385 32.8614Z"
      fill={bgFill}
    />
  </svg>
);

export const CheckboxIcon: React.FC<Props> = ({
  fill = '#FCCD33',
  bgFill = '#FFF9E4',
}) => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="56" rx="4" fill={fill} />
    <g transform="translate(12 12)">
      <path
        d="M9.33045 9.33341V4.00008C9.33045 3.26371 9.9274 2.66675 10.6638 2.66675H27.9971C28.7335 2.66675 29.3305 3.26371 29.3305 4.00008V21.3334C29.3305 22.0698 28.7335 22.6667 27.9971 22.6667H22.6641V27.9901C22.6641 28.7319 22.0654 29.3334 21.3207 29.3334H4.0071C3.26521 29.3334 2.66406 28.7349 2.66406 27.9901L2.66774 10.6767C2.6679 9.93484 3.26646 9.33341 4.01106 9.33341H9.33045ZM11.9971 9.33341H21.321C22.0627 9.33341 22.6641 9.93197 22.6641 10.6767V20.0001H26.6638V5.33341H11.9971V9.33341ZM19.9974 12.0001H5.33413L5.33101 26.6667H19.9974V12.0001ZM11.334 24.0001L6.61992 19.2861L8.50553 17.4005L11.334 20.2289L16.9909 14.5719L18.8765 16.4575L11.334 24.0001Z"
        fill={bgFill}
      />
    </g>
  </svg>
);

export const ListIdentLine: React.FC<Props> = ({
  fill = '#FFF9E4',
  bgFill = '#FCCD33',
}) => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="56" rx="4" fill={fill} />
    <path
      d="M29.333 17.332H39.9997V19.9987H29.333V17.332ZM29.333 26.6654H39.9997V29.332H29.333V26.6654ZM29.333 35.9987H39.9997V38.6654H29.333V35.9987ZM20.6663 37.332C19.1936 37.332 17.9997 36.1382 17.9997 34.6654C17.9997 33.1926 19.1936 31.9987 20.6663 31.9987C22.1391 31.9987 23.333 33.1926 23.333 34.6654C23.333 36.1382 22.1391 37.332 20.6663 37.332ZM20.6663 39.9987C23.6119 39.9987 25.9997 37.6108 25.9997 34.6654C25.9997 31.7199 23.6119 29.332 20.6663 29.332C17.7208 29.332 15.333 31.7199 15.333 34.6654C15.333 37.6108 17.7208 39.9987 20.6663 39.9987ZM18.6663 19.9987V23.9987H22.6663V19.9987H18.6663ZM15.9997 17.332H25.333V26.6654H15.9997V17.332Z"
      fill={bgFill}
    />
  </svg>
);

export const CashLine: React.FC<Props> = ({
  fill = '#EFEDFE',
  bgFill = '#5A4AF2',
}) => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="56" rx="4" fill={fill} />
    <path
      d="M28.0002 33.332C30.9457 33.332 33.3335 30.9442 33.3335 27.9987C33.3335 25.0532 30.9457 22.6654 28.0002 22.6654C25.0547 22.6654 22.6668 25.0532 22.6668 27.9987C22.6668 30.9442 25.0547 33.332 28.0002 33.332ZM40.0062 17.3359H16.0062C15.2698 17.3359 14.6729 17.9329 14.6729 18.6693V37.3359C14.6729 38.0723 15.2698 38.6692 16.0062 38.6692H40.0062C40.7426 38.6692 41.3395 38.0723 41.3395 37.3359V18.6693C41.3395 17.9329 40.7426 17.3359 40.0062 17.3359ZM17.3395 32.8604V23.137C18.8405 22.688 20.0242 21.5039 20.4724 20.0026H35.5279C35.9774 21.5079 37.1661 22.6944 38.6729 23.1406V32.8568C37.1635 33.3038 35.9733 34.4935 35.5255 36.0026H20.4747C20.0283 34.4976 18.8432 33.3102 17.3395 32.8604Z"
      fill={bgFill}
    />
  </svg>
);

export const ListCheck: React.FC<Props> = ({
  fill = '#E6EDEE',
  bgFill = '#054853',
}) => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="56" rx="4" fill={fill} />
    <path
      d="M22.6664 19.9987V23.9987H18.6664V19.9987H22.6664ZM15.9998 17.332V26.6654H25.3331V17.332H15.9998ZM29.3331 17.332H39.9998V19.9987H29.3331V17.332ZM29.3331 26.6654H39.9998V29.332H29.3331V26.6654ZM29.3331 35.9987H39.9998V38.6654H29.3331V35.9987ZM26.2759 33.6082L24.3903 31.7226L19.9998 36.1131L17.6092 33.7226L15.7236 35.6082L19.9998 39.8843L26.2759 33.6082Z"
      fill={bgFill}
    />
  </svg>
);

export const EBikeIcon: React.FC<Props> = ({
  fill = '#5A4AF2',
  bgFill = '#EFEDFE',
}) => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="56" rx="4" fill={fill} />
    <g transform="translate(12 12)">
      <path
        d="M20.6649 9.24905C23.4542 10.8629 25.3307 13.879 25.3307 17.3333V27.9999H19.7698C19.2207 29.5535 17.739 30.6666 15.9974 30.6666C14.2558 30.6666 12.7741 29.5535 12.225 27.9999H6.66406V17.3333C6.66406 13.879 8.54061 10.8629 11.3299 9.24905C11.1141 8.85992 10.9456 8.44096 10.8321 7.99992H6.66406V5.33325H10.8321C11.4241 3.03295 13.5123 1.33325 15.9974 1.33325C18.4825 1.33325 20.5706 3.03295 21.1627 5.33325H25.3307V7.99992H21.1627C21.0491 8.44096 20.8807 8.85992 20.6649 9.24905ZM18.7273 11.2493C17.9286 11.726 16.995 11.9999 15.9974 11.9999C14.9998 11.9999 14.0662 11.726 13.2676 11.2493C10.9468 12.2922 9.33073 14.6241 9.33073 17.3333V25.3333H11.9974V19.9999C11.9974 17.7907 13.7882 15.9999 15.9974 15.9999C18.2066 15.9999 19.9974 17.7907 19.9974 19.9999V25.3333H22.6641V17.3333C22.6641 14.6241 21.0479 12.2922 18.7273 11.2493ZM15.9974 18.6666C15.261 18.6666 14.6641 19.2635 14.6641 19.9999V26.6666C14.6641 27.403 15.261 27.9999 15.9974 27.9999C16.7338 27.9999 17.3307 27.403 17.3307 26.6666V19.9999C17.3307 19.2635 16.7338 18.6666 15.9974 18.6666ZM15.9974 9.33325C17.4702 9.33325 18.6641 8.13935 18.6641 6.66659C18.6641 5.19383 17.4702 3.99992 15.9974 3.99992C14.5246 3.99992 13.3307 5.19383 13.3307 6.66659C13.3307 8.13935 14.5246 9.33325 15.9974 9.33325Z"
        fill={bgFill}
      />
    </g>
  </svg>
);

export const BoxIcon: React.FC<Props> = ({
  fill = '#E6EDEE',
  bgFill = '#006475',
}) => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="56" rx="4" fill={fill} />
    <g transform="translate(15 15)">
      <path
        d="M13.0026 0.333252L25.6693 7.66659V22.3333L13.0026 29.6666L0.335938 22.3333V7.66659L13.0026 0.333252ZM4.32778 8.43685L13.0027 13.4591L21.6775 8.43691L13.0026 3.41459L4.32778 8.43685ZM3.0026 10.751V20.7958L11.6694 25.8134V15.7686L3.0026 10.751ZM14.3361 25.8133L23.0026 20.7958V10.7511L14.3361 15.7686V25.8133Z"
        fill={bgFill}
      />
    </g>
  </svg>
);

export const SearchIcon: React.FC<Props> = ({ fill = '#6B7079' }) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.4685 16.9098L22.7512 21.1925L21.337 22.6067L17.0543 18.324C15.5144 19.556 13.5615 20.293 11.4375 20.293C6.4695 20.293 2.4375 16.261 2.4375 11.293C2.4375 6.32497 6.4695 2.29297 11.4375 2.29297C16.4055 2.29297 20.4375 6.32497 20.4375 11.293C20.4375 13.417 19.7005 15.3699 18.4685 16.9098ZM16.4622 16.1678C17.685 14.9076 18.4375 13.1886 18.4375 11.293C18.4375 7.42547 15.305 4.29297 11.4375 4.29297C7.57 4.29297 4.4375 7.42547 4.4375 11.293C4.4375 15.1605 7.57 18.293 11.4375 18.293C13.3331 18.293 15.0521 17.5405 16.3123 16.3177L16.4622 16.1678Z"
      fill={fill}
    />
  </svg>
);

export const AccountPinIcon: React.FC<Props> = ({
  fill = '#EFEDFE',
  bgFill = '#5A4AF2',
}) => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="56" rx="4" fill={fill} />
    <g transform="translate(0 0)">
      <path
        d="M30.6667 40L28 42.6667L25.3333 40H18.6601C17.191 40 16 38.8099 16 37.3399V18.6601C16 17.191 17.1902 16 18.6601 16H37.3399C38.8091 16 40 17.1902 40 18.6601V37.3399C40 38.8091 38.8099 40 37.3399 40H30.6667ZM37.3333 37.3333V18.6667H18.6667V37.3333H26.4379L28 38.8955L29.5621 37.3333H37.3333ZM22.6295 36.2411C21.8046 35.8839 21.0229 35.4457 20.2944 34.9365C21.957 32.3671 24.848 30.6667 28.1363 30.6667C31.3353 30.6667 34.1585 32.2761 35.8401 34.7296C35.1251 35.2581 34.3552 35.7169 33.5407 36.0957C32.3296 34.4221 30.36 33.3333 28.1363 33.3333C25.8487 33.3333 23.8303 34.4855 22.6295 36.2411ZM28 29.3333C25.4227 29.3333 23.3333 27.244 23.3333 24.6667C23.3333 22.0893 25.4227 20 28 20C30.5773 20 32.6667 22.0893 32.6667 24.6667C32.6667 27.244 30.5773 29.3333 28 29.3333ZM28 26.6667C29.1045 26.6667 30 25.7712 30 24.6667C30 23.5621 29.1045 22.6667 28 22.6667C26.8955 22.6667 26 23.5621 26 24.6667C26 25.7712 26.8955 26.6667 28 26.6667Z"
        fill={bgFill}
      />
    </g>
  </svg>
);

export const UserFollowIcon: React.FC<Props> = ({
  fill = '#E6EDEE',
  bgFill = '#054853',
}) => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="56" rx="4" fill={fill} />
    <g transform="translate(0 0)">
      <path
        d="M30.6663 31.0014V33.7872C29.8322 33.4924 28.9347 33.332 27.9997 33.332C23.5814 33.332 19.9997 36.9138 19.9997 41.332H17.333C17.333 35.441 22.1086 30.6654 27.9997 30.6654C28.9205 30.6654 29.8141 30.782 30.6663 31.0014ZM27.9997 29.332C23.5797 29.332 19.9997 25.752 19.9997 21.332C19.9997 16.912 23.5797 13.332 27.9997 13.332C32.4197 13.332 35.9997 16.912 35.9997 21.332C35.9997 25.752 32.4197 29.332 27.9997 29.332ZM27.9997 26.6654C30.9463 26.6654 33.333 24.2787 33.333 21.332C33.333 18.3854 30.9463 15.9987 27.9997 15.9987C25.053 15.9987 22.6663 18.3854 22.6663 21.332C22.6663 24.2787 25.053 26.6654 27.9997 26.6654ZM35.7235 38.551L40.4375 33.837L42.3231 35.7226L35.7235 42.3222L31.0095 37.6082L32.8951 35.7226L35.7235 38.551Z"
        fill={bgFill}
      />
    </g>
  </svg>
);

export const UserUnFollowIcon: React.FC<Props> = ({
  fill = '#FFF2EA',
  bgFill = '#F7742B',
}) => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="56" rx="4" fill={fill} />
    <g transform="translate(0 0)">
      <path
        d="M30.6663 31.0014V33.7872C29.8322 33.4924 28.9347 33.332 27.9997 33.332C23.5814 33.332 19.9997 36.9138 19.9997 41.332H17.333C17.333 35.441 22.1086 30.6654 27.9997 30.6654C28.9205 30.6654 29.8141 30.782 30.6663 31.0014ZM27.9997 29.332C23.5797 29.332 19.9997 25.752 19.9997 21.332C19.9997 16.912 23.5797 13.332 27.9997 13.332C32.4197 13.332 35.9997 16.912 35.9997 21.332C35.9997 25.752 32.4197 29.332 27.9997 29.332ZM27.9997 26.6654C30.9463 26.6654 33.333 24.2787 33.333 21.332C33.333 18.3854 30.9463 15.9987 27.9997 15.9987C25.053 15.9987 22.6663 18.3854 22.6663 21.332C22.6663 24.2787 25.053 26.6654 27.9997 26.6654ZM37.333 35.4464L40.1614 32.618L42.047 34.5036L39.2186 37.332L42.047 40.1604L40.1614 42.046L37.333 39.2176L34.5046 42.046L32.619 40.1604L35.4474 37.332L32.619 34.5036L34.5046 32.618L37.333 35.4464Z"
        fill={bgFill}
      />
    </g>
  </svg>
);

export const DrawerIcon: React.FC<Props> = ({ fill = '#FCCD33' }) => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="56" rx="4" fill="#FFF9E4" />
    <path
      d="M16 15.9894C16 15.2591 16.5933 14.667 17.3245 14.667H38.6755C39.4069 14.667 40 15.2741 40 15.9894V40.0113C40 40.7417 39.4068 41.3337 38.6755 41.3337H17.3245C16.593 41.3337 16 40.7266 16 40.0113V15.9894ZM37.3333 26.667V17.3337H18.6667V26.667H37.3333ZM37.3333 29.3337H18.6667V38.667H37.3333V29.3337ZM24 20.0003H32V22.667H24V20.0003ZM24 32.0003H32V34.667H24V32.0003Z"
      fill={fill}
    />
  </svg>
);

export const DebitIcon = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="56" rx="4" fill="#FCECE4" />
    <g clipPath="url(#clip0_56842_52180)">
      <path
        d="M33.3376 24.5523L21.8622 36.0277L19.9766 34.1421L31.452 22.6667H21.3377V20H36.0043V34.6667H33.3376V24.5523Z"
        fill="#F7742B"
      />
    </g>
    <defs>
      <clipPath id="clip0_56842_52180">
        <rect
          width="32"
          height="32"
          fill="white"
          transform="translate(12 12)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const InformationIcon: React.FC<Props> = ({ fill = '#081120' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM13 10.5V15H14V17H10V15H11V12.5H10V10.5H13ZM13.5 8C13.5 8.82843 12.8284 9.5 12 9.5C11.1716 9.5 10.5 8.82843 10.5 8C10.5 7.17157 11.1716 6.5 12 6.5C12.8284 6.5 13.5 7.17157 13.5 8Z"
      fill={fill}
    />
  </svg>
);

export const CopyLinkIcon: React.FC<Props> = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0609 6.11122L12.4751 7.52543C15.2088 10.2591 15.2088 14.6912 12.4751 17.4249L12.1216 17.7784C9.38795 20.5121 4.9558 20.5121 2.22213 17.7784C-0.511543 15.0448 -0.511543 10.6126 2.22213 7.87899L3.63635 9.29325C1.68373 11.2458 1.68373 14.4116 3.63635 16.3642C5.58897 18.3168 8.75475 18.3168 10.7074 16.3642L11.0609 16.0107C13.0135 14.058 13.0135 10.8922 11.0609 8.93965L9.64675 7.52543L11.0609 6.11122ZM17.7784 12.1216L16.3642 10.7074C18.3168 8.75475 18.3168 5.58897 16.3642 3.63635C14.4116 1.68373 11.2458 1.68373 9.29325 3.63635L8.93965 3.9899C6.98703 5.94252 6.98703 9.10835 8.93965 11.0609L10.3538 12.4751L8.93965 13.8893L7.52543 12.4751C4.79176 9.74155 4.79176 5.30936 7.52543 2.57569L7.87899 2.22213C10.6126 -0.511543 15.0448 -0.511543 17.7784 2.22213C20.5121 4.9558 20.5121 9.38795 17.7784 12.1216Z"
      fill="#081120"
    />
  </svg>
);

export const QRcodeIcon: React.FC<Props> = ({
  fill = '#081120',
  width = '24',
  height = '24',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 17.5V16.5H13V13.5H16V15.5H18V17.5H17V19.5H15V21.5H13V18.5H15V17.5H16ZM21 21.5H17V19.5H19V17.5H21V21.5ZM3 3.5H11V11.5H3V3.5ZM5 5.5V9.5H9V5.5H5ZM13 3.5H21V11.5H13V3.5ZM15 5.5V9.5H19V5.5H15ZM3 13.5H11V21.5H3V13.5ZM5 15.5V19.5H9V15.5H5ZM18 13.5H21V15.5H18V13.5ZM6 6.5H8V8.5H6V6.5ZM6 16.5H8V18.5H6V16.5ZM16 6.5H18V8.5H16V6.5Z"
      fill={fill}
    />
  </svg>
);

export const DownloadLineIcon: React.FC<Props> = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.25 14.25H15.75V15.75H2.25V14.25ZM9.75 9.8787L14.3033 5.32538L15.364 6.38604L9 12.75L2.63604 6.38604L3.6967 5.32538L8.25 9.8787V1.5H9.75V9.8787Z"
      fill="#054853"
    />
  </svg>
);

export const EllipseSvg: React.FC<{
  height?: string;
  width?: string;
}> = ({ height = '4', width = 3 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 3 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="1.5" cy="2.36328" r="1.5" fill="#8E8E93" />
  </svg>
);

export const ArrowRightIcon: React.FC<Props> = ({
  fill = '#081120',
  width = '20',
  height = '15',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 13 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.3536 4.35355C12.5488 4.15829 12.5488 3.84171 12.3536 3.64645L9.17157 0.464466C8.97631 0.269204 8.65973 0.269204 8.46447 0.464466C8.2692 0.659728 8.2692 0.976311 8.46447 1.17157L11.2929 4L8.46447 6.82843C8.2692 7.02369 8.2692 7.34027 8.46447 7.53553C8.65973 7.7308 8.97631 7.7308 9.17157 7.53553L12.3536 4.35355ZM0 4.5L12 4.5L12 3.5L0 3.5L0 4.5Z"
      fill={fill}
    />
  </svg>
);

export const GearIcon: React.FC<Props> = ({
  fill = '#081120',
  width = '16',
  height = '16',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 8.00229C0.5 7.35391 0.582275 6.72474 0.736962 6.12467C1.55466 6.16706 2.36636 5.76005 2.80385 5.00231C3.241 4.24513 3.18805 3.33947 2.74341 2.6527C3.63766 1.77391 4.75124 1.11761 5.99452 0.773438C6.36665 1.50283 7.12498 2.00231 8 2.00231C8.87502 2.00231 9.63335 1.50283 10.0055 0.773438C11.2488 1.11761 12.3624 1.77391 13.2566 2.6527C12.8119 3.33947 12.759 4.24513 13.1961 5.00231C13.6336 5.76005 14.4453 6.16706 15.2631 6.12467C15.4177 6.72474 15.5 7.35391 15.5 8.00229C15.5 8.65066 15.4177 9.27984 15.2631 9.87992C14.4453 9.83754 13.6336 10.2446 13.1961 11.0023C12.759 11.7595 12.8119 12.6651 13.2566 13.3519C12.3624 14.2307 11.2488 14.887 10.0055 15.2312C9.63335 14.5018 8.87502 14.0023 8 14.0023C7.12498 14.0023 6.36665 14.5018 5.99452 15.2312C4.75124 14.887 3.63766 14.2307 2.74341 13.3519C3.18805 12.6651 3.241 11.7595 2.80385 11.0023C2.36636 10.2446 1.55466 9.83754 0.736962 9.87992C0.582275 9.27984 0.5 8.65066 0.5 8.00229ZM4.10289 10.2523C4.57546 11.0708 4.71093 12.0119 4.52613 12.8951C4.83198 13.1128 5.15754 13.3013 5.49867 13.458C6.17132 12.8558 7.0544 12.5023 8 12.5023C8.9456 12.5023 9.82865 12.8558 10.5013 13.458C10.8424 13.3013 11.168 13.1128 11.4739 12.8951C11.2891 12.0119 11.4245 11.0708 11.8972 10.2523C12.3696 9.43382 13.1169 8.84604 13.9741 8.56441C13.9913 8.37856 14 8.19114 14 8.00229C14 7.81351 13.9913 7.62601 13.9741 7.44024C13.1169 7.15861 12.3696 6.57084 11.8972 5.75231C11.4245 4.93378 11.2891 3.99277 11.4739 3.10948C11.168 2.89185 10.8424 2.70329 10.5013 2.54658C9.82865 3.14877 8.9456 3.50231 8 3.50231C7.0544 3.50231 6.17132 3.14877 5.49867 2.54658C5.15754 2.70329 4.83198 2.89185 4.52613 3.10948C4.71093 3.99277 4.57546 4.93378 4.10289 5.75231C3.63032 6.57084 2.88316 7.15861 2.02588 7.44024C2.00868 7.62601 2 7.81351 2 8.00229C2 8.19114 2.00868 8.37856 2.02588 8.56441C2.88316 8.84604 3.63032 9.43382 4.10289 10.2523ZM8 10.2523C6.75733 10.2523 5.75 9.24496 5.75 8.00229C5.75 6.75969 6.75733 5.75231 8 5.75231C9.24267 5.75231 10.25 6.75969 10.25 8.00229C10.25 9.24496 9.24267 10.2523 8 10.2523ZM8 8.75229C8.41423 8.75229 8.75 8.41651 8.75 8.00229C8.75 7.58806 8.41423 7.25229 8 7.25229C7.58577 7.25229 7.25 7.58806 7.25 8.00229C7.25 8.41651 7.58577 8.75229 8 8.75229Z"
      fill={fill}
    />
  </svg>
);

export const SwitchIcon: React.FC<Props> = ({
  fill = '#F7F7F7',
  width = '16',
  height = '14',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.96369 3.96231L6.90304 5.02297L5.00194 3.121L5.00138 13H3.50137L3.50194 3.121L1.59973 5.02297L0.539062 3.96231L4.25137 0.25L7.96369 3.96231ZM15.4637 10.0377L11.7513 13.75L8.03907 10.0377L9.09972 8.977L11.0019 10.879L11.0013 1H12.5013L12.5019 10.879L14.403 8.977L15.4637 10.0377Z"
      fill={fill}
    />
  </svg>
);

export const CancelIcon: React.FC<Props> = ({
  fill = '#F7742B',
  width = '72',
  height = '72',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.50782 0.875C6.90084 0.875 5.32996 1.35152 3.99381 2.24431C2.65766 3.1371 1.61626 4.40605 1.00129 5.8907C0.386333 7.37535 0.225431 9.00901 0.538936 10.5851C0.852441 12.1612 1.62627 13.6089 2.76257 14.7452C3.89888 15.8815 5.34661 16.6554 6.92271 16.9689C8.4988 17.2824 10.1325 17.1215 11.6171 16.5065C13.1018 15.8916 14.3707 14.8502 15.2635 13.514C16.1563 12.1779 16.6328 10.607 16.6328 9C16.6305 6.84581 15.7738 4.78051 14.2505 3.25727C12.7273 1.73403 10.662 0.877275 8.50782 0.875ZM8.50782 15.875C7.14807 15.875 5.81886 15.4718 4.68827 14.7164C3.55768 13.9609 2.6765 12.8872 2.15614 11.6309C1.63579 10.3747 1.49964 8.99237 1.76492 7.65875C2.03019 6.32513 2.68497 5.10013 3.64646 4.13864C4.60794 3.17716 5.83295 2.52237 7.16657 2.2571C8.50019 1.99183 9.88252 2.12798 11.1388 2.64833C12.395 3.16868 13.4687 4.04987 14.2242 5.18045C14.9796 6.31104 15.3828 7.64025 15.3828 9C15.3807 10.8227 14.6558 12.5702 13.3669 13.8591C12.078 15.1479 10.3305 15.8729 8.50782 15.875ZM7.88282 9.625V5.25C7.88282 5.08424 7.94866 4.92527 8.06587 4.80806C8.18308 4.69085 8.34206 4.625 8.50782 4.625C8.67358 4.625 8.83255 4.69085 8.94976 4.80806C9.06697 4.92527 9.13282 5.08424 9.13282 5.25V9.625C9.13282 9.79076 9.06697 9.94973 8.94976 10.0669C8.83255 10.1842 8.67358 10.25 8.50782 10.25C8.34206 10.25 8.18308 10.1842 8.06587 10.0669C7.94866 9.94973 7.88282 9.79076 7.88282 9.625ZM9.44532 12.4375C9.44532 12.6229 9.39033 12.8042 9.28732 12.9583C9.1843 13.1125 9.03789 13.2327 8.86658 13.3036C8.69528 13.3746 8.50678 13.3932 8.32492 13.357C8.14306 13.3208 7.97602 13.2315 7.8449 13.1004C7.71379 12.9693 7.6245 12.8023 7.58833 12.6204C7.55216 12.4385 7.57072 12.25 7.64168 12.0787C7.71264 11.9074 7.8328 11.761 7.98697 11.658C8.14114 11.555 8.3224 11.5 8.50782 11.5C8.75646 11.5 8.99491 11.5988 9.17073 11.7746C9.34654 11.9504 9.44532 12.1889 9.44532 12.4375Z"
      fill={fill}
    />
  </svg>
);

export const CopyIcon: React.FC<Props> = ({
  fill = '#3B82F6',
  width = '16',
  height = '16',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 12.9V17.1C16 20.6 14.6 22 11.1 22H6.9C3.4 22 2 20.6 2 17.1V12.9C2 9.4 3.4 8 6.9 8H11.1C14.6 8 16 9.4 16 12.9Z"
      fill={fill}
    />
    <path
      d="M17.1 2H12.9C9.5 2 8.1 3.3 8.02 6.5C8.01 6.7 8.14 6.9 8.3 7.02C8.5 7.13 8.71 7.06 8.86 6.9C9.65 6.14 10.75 5.67 12 5.67H17.1C19.6 5.67 20.5 6.57 20.5 9.07V14.17C20.5 15.54 20.02 16.71 19.17 17.5C19.01 17.65 18.96 17.87 19.07 18.06C19.18 18.24 19.39 18.36 19.58 18.35C22.66 18.25 24 16.83 24 13.31V9.07C24 3.9 22.1 2 17.1 2Z"
      fill={fill}
    />
  </svg>
);
